import {
  CreateCustomerEntity,
  CustomerEntity,
  CustomerParams,
} from '@/pages/privatePages/customer/types';
import { BaseService } from './base.service';
import APIService from './axios.service';
import { AxiosResponse } from 'axios';
import { streamQuantityEventName } from '@/components/commonComponents/ExportByColumnModal';

class CustomerServiceClass extends BaseService<
  'customer',
  CustomerEntity,
  CreateCustomerEntity
> {
  constructor() {
    super('customer');
  }

  exportAll = (params: CustomerParams): Promise<AxiosResponse> => {
    return APIService.get(this.path, { params });
  };

  streamCustomer = (params: CustomerParams): Promise<any> => {
    return APIService.get(this.path + '/stream', {
      params,
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch kit quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamQuantityEventName, {
            detail: { percentProgress: lastProgress },
          }),
        );
      },
    });
  };
}
export const customerService = new CustomerServiceClass();
